import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom'
import AppShell from './components/AppShell'
import { PanelProvider } from './lib/panelContext'
import { TalkLogProvider } from './lib/talkLog'
import { TrainerTokenProvider } from './lib/trainerToken'
import { loadRuntime, publicMode } from './lib/runtime'
import Agents from './pages/Agents'
import Console from './pages/Console'
import Settings from './pages/Settings'
import Talk from './pages/Talk'
import TextChat from './pages/TextChat'
import Trainer from './pages/Trainer'
import './index.css'

function App() {
  return (
    <Router>
      <PanelProvider networked={!publicMode}>
        <TalkLogProvider>
        <TrainerTokenProvider>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/" element={<Navigate to="/text" replace />} />
            <Route path="/text" element={<TextChat />} />
            <Route path="/voice" element={<Talk mode="voice" />} />
            <Route path="/console" element={<Console />} />
            <Route path="/rooms" element={<Navigate to="/text" replace />} />
            <Route path="/trainer" element={<Trainer />} />
            <Route path="/agents" element={publicMode ? <Navigate to="/text" replace /> : <Agents />} />
            <Route path="/settings" element={publicMode ? <Navigate to="/text" replace /> : <Settings />} />
          </Route>
          <Route path="/talk" element={<Navigate to="/text" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </TrainerTokenProvider>
        </TalkLogProvider>
      </PanelProvider>
    </Router>
  )
}

void loadRuntime().then(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
